import type { AppThunkDispatch } from '@gift_cards/actions/thunkType';
import CommonError from '@gift_cards/components/CommonError';
import type { AppState } from '@gift_cards/reducers';
import {
  getHasAuthenticationError,
  getHasInternalServerError,
  getHasNotFoundError
} from '@gift_cards/selectors/getError';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  hasNotFoundError: getHasNotFoundError(state),
  hasAuthenticationError: getHasAuthenticationError(state),
  hasInternalServerError: getHasInternalServerError(state)
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({});

export type CommonErrorPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type CommonErrorPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(CommonError);
